import { connect } from "react-redux";
import {
  Box,
  Table,
  Text,
} from "@chakra-ui/react";
import OrganizationTicketsLineGraph from "../../charts/daily/OrganizationTicketsLineGraph";
import { formatNumber } from "../../../../store/helpers";

const AllTicketsTable = ({ table, chart, reportIndex }) => {
  return (
    <Box mt={10}>
      <Box>
        {table.map((a, index) => (
          <Box className="reportContainer" key={index}>
            <Box mb="10px">
              <h3>
                {reportIndex}. {index + 1}. {a.name}
              </h3>
            </Box>
            <Table.Root key={index} className="stripedTable" size="sm">
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Total Tickets</Table.ColumnHeader>
                  <Table.ColumnHeader>Avg /Hour.</Table.ColumnHeader>
                  <Table.ColumnHeader>Min.</Table.ColumnHeader>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Max</Table.ColumnHeader>
                  <Table.ColumnHeader>Completed</Table.ColumnHeader>
                  <Table.ColumnHeader>No Show</Table.ColumnHeader>
                  <Table.ColumnHeader>Unattended</Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell borderRight="1px solid #dadce0">
                    <Text color={"var(--blue)"}>{formatNumber(a.total)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatNumber(a.averageTicketsPerHour)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatNumber(a.minTicketsPerHour)}</Text>
                  </Table.Cell>
                  <Table.Cell borderRight="1px solid #dadce0">
                    <Text>{formatNumber(a.maxTicketsPerHour)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text color={"var(--green)"}>
                      {formatNumber(a.completed)}
                      <Text
                        color="gray.500"
                        fontWeight="semibold"
                        fontSize="xs"
                        textTransform="uppercase"
                      >
                        ({a.pctCompleted.toFixed(2)}%)
                      </Text>
                    </Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text cursor="pointer" color={"var(--red)"}>
                      {formatNumber(a.noShow)}
                      <Text
                        color="gray.500"
                        fontWeight="semibold"
                        fontSize="xs"
                        textTransform="uppercase"
                      >
                        ({a.pctNoShow.toFixed(2)}%)
                      </Text>
                    </Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text color={"var(--red)"}>
                      {formatNumber(a.unattended)}
                      <Text
                        color="gray.500"
                        fontWeight="semibold"
                        fontSize="xs"
                        textTransform="uppercase"
                      >
                        ({a.pctUnattended.toFixed(2)}%)
                      </Text>
                    </Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table.Root>
            <Box className="ticketOutcomeChartBlock">
              <OrganizationTicketsLineGraph
                title="Entire Organization: Hour by hour comparison"
                chart={chart}
                chartHeight="300px"
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  const { defaultReducer } = state;
  return {
    tickets: defaultReducer.tickets,
  };
};

export default connect(mapStateToProps, {})(AllTicketsTable);
